var baseApiUrl = process.env.REACT_APP_MANAGE_ISSUE_BASE_URL;
const baseurl = baseApiUrl + "api";
const baseurlformanagequality = baseurl + "/managequality";
export const BASE_URL_QUALITY = baseurlformanagequality;
export const MANAGE_QUALITY_GET = BASE_URL_QUALITY + "/getallmanagequality";
export const MANAGE_QUALITY_EXPORT = BASE_URL_QUALITY + "/exportmanagequality";
export const MANAGE_DOWNLOAD=BASE_URL_QUALITY+"/getinputandoutputfile"
